import Image from '~/components/image/Image'
import { useIsPC } from '~/lib/ua'
import { css, cx, sva } from '~/styled-system/css'
import { vstack } from '~/styled-system/patterns'

export const FooterBanners = import.meta.env.VITE_MODE === 'ppg' ? EmptyBanners : IkyuBanners

function EmptyBanners() {
  return null
}

function IkyuBanners() {
  return (
    <div
      className={css({
        textAlign: 'center',
        _sd: { bg: 'gray.100', p: '3' },
        _pc: { pt: '16', borderTop: 'light' },
      })}
    >
      <ul
        className={css({
          _sd: { spaceY: '3' },
          _pc: { display: 'flex', spaceX: '5' },
        })}
      >
        <li>
          <SupremeRestaurantBanner />
        </li>
        <li>
          <KiwaminoBanner />
        </li>
        <li>
          <ListingBanner />
        </li>
      </ul>
    </div>
  )
}

const styles = sva({
  slots: ['background', 'title', 'description'],
  base: {
    background: vstack.raw({
      display: 'flex',
      color: 'gray.100',
      w: { base: 'full', _pc: '[320px]' },
      h: { base: 'auto', _pc: '[120px]' },
      backgroundSize: 'cover',
      backgroundPosition: { base: 'top', _pc: 'center' },
      _pc: {
        justifyContent: 'center',
        rounded: 'md',
        transition: '[opacity 0.2s]',
        _hover: { opacity: '75' },
      },
      _sd: {
        pl: '4',
        textAlign: 'left',
        justifyContent: 'center',
        alignItems: 'start',
        aspectRatio: '351/79',
      },
      gap: '0',
    }),
    description: {
      fontSize: 'sm',
    },
  },
  variants: {
    serif: {
      false: {
        title: {
          fontWeight: 'bold',
          fontSize: { base: 'xl', _pc: '2xl' },
        },
      },
      true: {
        title: {
          fontFamily: 'serif',
          fontSize: { base: '2xl', _pc: '3xl' },
        },
      },
    },
  },
  defaultVariants: {
    serif: false,
  },
})

function SupremeRestaurantBanner() {
  const { background, title, description } = styles({ serif: true })
  return (
    <a
      href="/specials/supreme/"
      className={cx(
        css({
          backgroundImage: `url('https://restaurant.img-ikyu.com/rsImg/top/banner/supreme.jpg')`,
        }),
        background
      )}
    >
      <p className={title}>至高のレストラン</p>
      <p className={description}>一休.comレストラン厳選の名店、人気店</p>
    </a>
  )
}

function KiwaminoBanner() {
  const isPC = useIsPC()
  const { background, description } = styles()

  return (
    <a
      href="https://www.kiwamino.com/"
      className={cx(
        css({
          backgroundImage: `url('https://restaurant.img-ikyu.com/rsImg/top/banner/kiwamino.jpg')`,
        }),
        background
      )}
      target="_blank"
      rel="noopener noreferrer"
    >
      <Image
        src="https://restaurant.img-ikyu.com/rsImg/top/banner/kiwamino_logo.svg"
        alt="KIWAMINO"
        width={isPC ? 136 : 118}
        height={isPC ? 18 : 16}
        className={css({ display: 'block', mb: '1' })}
      />
      <p className={description}>食通のためのグルメ情報</p>
    </a>
  )
}

function ListingBanner() {
  const { background, title, description } = styles()
  return (
    <a
      href="https://restaurant.ikyu.com/join"
      className={cx(
        css({
          backgroundImage: `url('https://restaurant.img-ikyu.com/rsImg/top/main_02.jpg?crop=top')`,
          color: 'white',
        }),
        background
      )}
    >
      <p className={title}>掲載希望の店舗様へ</p>
      <p className={description}>掲載申込み・資料請求</p>
    </a>
  )
}
